export default "__VITE_ASSET__4yyfkOOT__"